import css from "./CardView.sass?inline"
import {Html} from "@opendaw/lib-dom"
import {createElement, JsxValue} from "@opendaw/lib-jsx"
import {Track} from "@/api"

const className = Html.adoptStyleSheet(css, "CardView")

type Construct = {
    track: Track
    onEnded?: () => void
    onTagClick?: (tag: string) => void
}

const linkify = (text: string, target?: string): JsxValue => text
    .split(/(https?:\/\/\S+|www\.\S+)/g)
    .map((part, i) => i % 2
        ? <a href={part.startsWith("http") ? part : `https://${part}`} target={target}>{part}</a>
        : part)

export const CardView = ({track, onEnded, onTagClick}: Construct) => {
    const coverUrl = track.hasCover ? `https://api.opendaw.studio/music/cover.php?id=${track.id}` : "./cover.png"

    const openInStudioUrl = `${location.hostname === "localhost"
        ? "https://localhost:8081/"
        : "https://opendaw.studio/"
    }open-bundle/${track.id}`
    return (
        <div className={className}>
            <div className="cover">
                <img alt="cover"
                     src={coverUrl}
                     className="glow"
                     crossOrigin="true"
                     onInit={element => element.addEventListener("error", () => element.src = "./cover.png")}/>
                <img alt="cover"
                     src={coverUrl}
                     crossOrigin="true"
                     onInit={element => element.addEventListener("error", () => element.src = "./cover.png")}/>
            </div>
            <div className="info">
                <h1>{track.metadata.name}</h1>
                <h2>{track.metadata.artist ?? "Unknown Artist"}</h2>
                <div className={onTagClick ? "tags clickable" : "tags"}>
                    {track.metadata.tags.slice(0, 10).map(tag => (
                        <div onclick={onTagClick ? () => onTagClick(tag) : undefined}>{tag}</div>
                    ))}
                </div>
            </div>
            <div className="dates">
                <div>Created <span>{new Date(track.metadata.created).toLocaleDateString()}</span></div>
                <div>Modified <span>{new Date(track.metadata.modified).toLocaleDateString()}</span></div>
            </div>
            <p className="description">{linkify(track.metadata.description, "_blank")}</p>
            <div className="actions">
                <div className="share-button" onclick={async () => {
                    const url = `https://music.opendaw.studio/track/${track.id}`
                    try {
                        await navigator.clipboard.writeText(url)
                        alert(`URL copied to clipboard:\n${url}`)
                    } catch (error) {
                        console.error("Failed to copy URL to clipboard:", error)
                        alert("Failed to copy URL to clipboard. Please try again.")
                    }
                }} style={{cursor: "pointer"}}>SHARE
                </div>
                <div className="open-button" onclick={() => window.open(openInStudioUrl)}>OPEN IN STUDIO</div>
            </div>
            <audio controls={true}
                   controlsList="nodownload noplaybackrate"
                   crossOrigin="true"
                   src={`https://api.opendaw.studio/music/uploads/${track.id}/mixdown.mp3`}
                   onended={onEnded}/>
        </div>
    )
}